import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';

import { Dashboard } from '@/features/dashboard/Dashboard';
import PageLayout from '@/layout/PageLayout';

const DashboardPage = () => (
    <ApplicationLayout.Body>
        <PageLayout>
            <Dashboard />
        </PageLayout>
    </ApplicationLayout.Body>
);

export default DashboardPage;
